import React, { useState, useRef } from 'react';
import {  } from 'react-router-dom';
import { IoClose, IoMenu } from 'react-icons/io5';
import Logo from '../images/image.png';
import './TopNav.css';
import Resume from '../usman.pdf';

const TopNav = () => {
    const [showMenu, setShowMenu] = useState(false);

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    return (
        <header className="header">
            <nav className="TopNav">
                <a href="#">
                    <img className="logo-img" src={Logo} alt="logo"/> 
                </a>
                <div className={`nav-menu ${showMenu ? 'active' : ''}`}>
                    <ul className="nav-list">
                        <li className="nav-item">
                            <a className="nav-link" href="#about" onClick={toggleMenu}> 
                                <span className="nav-link-hightlight-text">01.</span> 
                                <span className="nav-link-text">About</span> 
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#experience" onClick={toggleMenu}> 
                                <span className="nav-link-hightlight-text">02.</span> 
                                <span className="nav-link-text">Experience</span> 
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#projects" onClick={toggleMenu}> 
                                <span className="nav-link-hightlight-text">03.</span> 
                                <span className="nav-link-text">Projects</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#contact" onClick={toggleMenu}> 
                                <span className="nav-link-hightlight-text">04.</span> 
                                <span className="nav-link-text">Contact</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <div className="nav-btn-div">
                                <a href={Resume} target="_blank" className="primary-button">Resume</a>
                            </div>
                        </li>
                    </ul>
                    <div className="nav-close" onClick={toggleMenu}>
                        {showMenu ? <IoClose />: '' }
                    </div>
                    <div className="nav-toggle" onClick={toggleMenu}>
                        {!showMenu ? <IoMenu />: '' }
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default TopNav;
